<div class="modal-content">


    <div class="text-right">
        <mat-icon mat-dialog-close class="close-button">close</mat-icon>
    </div>

    <div class="content scrollable-content">
        <form [formGroup]="myshipForm">



            <h4 class="section-title">🚢 Load Ports</h4>

            <div class="port-header-row row g-2">
                <div class="col-md-3 header-col port-name-header">Port Name</div>
                <div class="col-md-9 header-col events-header">
                    <div class="row g-1">
                        <div class="col-4">EOSP</div>
                        <div class="col-4">All Fast</div>
                        <div class="col-4">COSP</div>
                    </div>
                </div>
            </div>

            <div formArrayName="load_ports">
                <div class="port-row-item row g-2" *ngFor="let group of loadPorts.controls; let i=index"
                    [formGroupName]="i">

                    <div class="col-md-3 port-input-col">
                        <label class="port-label">Port {{ i + 1 }}:</label>
                        <input type="text" class="form-control" placeholder="Port Name" formControlName="port_name" />
                    </div>

                    <div class="col-md-9 event-inputs-container" formGroupName="events">
                        <div class="row g-1 event-row">

                            <ng-container *ngFor="let event of ['eosp', 'all_fast', 'cosp']">
                                <div class="col-4 event-col-4">
                                    <div class="event-input-group">
                                        <input type="date" class="form-control date-input"
                                            [formControlName]="event + 'Date'" placeholder="dd-mm-yyyy" />
                                        <div class="time-picker-group">
                                            <input placeholder="HH" type="number" class="form-control time-input"
                                                min="0" max="23" [formControlName]="event + 'Hours'"
                                                (input)="restrictInput($event.target, 23)" />
                                            <input placeholder="MM" type="number" class="form-control time-input"
                                                min="0" max="59" [formControlName]="event + 'Minutes'"
                                                (input)="restrictInput($event.target, 59)" />
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <div class="port-actions">
                        <mat-icon class="action-icon add-icon"
                            *ngIf="i === loadPorts.length - 1 && loadPorts.length < 8" (click)="addLoadPort()"
                            matTooltip="Add Load Port">
                            add_circle
                        </mat-icon>
                        <mat-icon class="action-icon remove-icon" *ngIf="loadPorts.length > 1"
                            (click)="removeLoadPort(i)" matTooltip="Remove Load Port">
                            remove_circle_outline
                        </mat-icon>
                    </div>
                </div>
            </div>



            <h4 class="section-title">⚓ Discharge Ports</h4>

            <div class="port-header-row row g-2">
                <div class="col-md-3 header-col port-name-header">Port Name</div>
                <div class="col-md-9 header-col events-header">
                    <div class="row g-1">
                        <div class="col-4">EOSP</div>
                        <div class="col-4">All Fast</div>
                        <div class="col-4">COSP</div>
                    </div>
                </div>
            </div>

            <div formArrayName="discharge_ports">
                <div class="port-row-item row g-2" *ngFor="let group of dischargePorts.controls; let i=index"
                    [formGroupName]="i">

                    <div class="col-md-3 port-input-col">
                        <label class="port-label">Port {{ i + 1 }}:</label>
                        <input type="text" class="form-control" placeholder="Port Name" formControlName="port_name" />
                    </div>

                    <div class="col-md-9 event-inputs-container" formGroupName="events">
                        <div class="row g-1 event-row">

                            <ng-container *ngFor="let event of ['eosp', 'all_fast', 'cosp']">
                                <div class="col-4 event-col-4">
                                    <div class="event-input-group">
                                        <input type="date" class="form-control date-input"
                                            [formControlName]="event + 'Date'" placeholder="dd-mm-yyyy" />
                                        <div class="time-picker-group">
                                            <input placeholder="HH" type="number" class="form-control time-input"
                                                min="0" max="23" [formControlName]="event + 'Hours'"
                                                (input)="restrictInput($event.target, 23)" />
                                            <input placeholder="MM" type="number" class="form-control time-input"
                                                min="0" max="59" [formControlName]="event + 'Minutes'"
                                                (input)="restrictInput($event.target, 59)" />
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <div class="port-actions">
                        <mat-icon class="action-icon add-icon"
                            *ngIf="i === dischargePorts.length - 1 && dischargePorts.length < 8"
                            (click)="addDischargePort()" matTooltip="Add Discharge Port">
                            add_circle
                        </mat-icon>
                        <mat-icon class="action-icon remove-icon" *ngIf="dischargePorts.length > 1"
                            (click)="removeDischargePort(i)" matTooltip="Remove Discharge Port">
                            remove_circle_outline
                        </mat-icon>
                    </div>
                </div>
            </div>

            <br>

            <div class="text-right mb-4">
                <!-- Clear Button -->
                <button class="btn btn-light hover-button mail " (click)="clearClick()">
                    <mat-icon>clear_all</mat-icon>&nbsp; Clear
                </button>

                <!-- Upload Excel Button -->
                <button class="btn btn-light hover-button mail" (click)="fileInput.click()"
                    matTooltip="Upload Excel file here" matTooltipPosition="above">
                    <mat-icon>file_upload</mat-icon>&nbsp; Upload File
                </button>

                <input type="file" #fileInput accept=".xlsx, .xls" (change)="uploadFile($event)" hidden />

                <!-- Generate Report Button: only visible after file upload -->
                <button *ngIf="fileUploaded" class="btn btn-light hover-button mail1" style="width: 230px;"
                    (click)="createFinalReport()">
                    <mat-icon>description</mat-icon>&nbsp; Generate Final Report
                </button>



            </div>

        </form>
    </div>
</div>